/* Warehouse Bold — cart drawer "Pair Well With": the heading-row arrows.
 *
 * The row is a CSS snap strip (.wb-rec__grid in wb-cart.css) showing whole
 * tiles only — three a page on desktop, two on phones. This file drives the
 * two arrows in the heading row the same way assets/wb-addons.js drives the
 * product page's add-on strip, and the paging rules are copied from there:
 *
 *   · a page is `per` tiles = floor((port + gap) / pitch), pitch = tile + gap;
 *   · paging is by TILE INDEX from a remembered target, not a relative
 *     scrollBy — scrollBy resolves against the mid-glide position, so a quick
 *     second click compounds into the snap and lands off-page;
 *   · Prev from the clamped last page returns to the page boundary before it,
 *     not "one page back from wherever the clamp stopped";
 *   · aria-disabled, not disabled — a button that disables itself under
 *     keyboard focus drops focus to body;
 *   · offsets are signed by writing direction (scrollLeft runs negative in an
 *     RTL scroller) and clamped, so the iOS rubber-band cannot flicker Prev on
 *     at the start edge;
 *   · the nav hides itself whenever every tile already fits.
 *
 * ⚠ Nothing is bound at page load. cart.js replaces the element's innerHTML
 * after each fetch and the whole drawer body on every cart change, so every
 * fill is a fresh set of nodes. The theme dispatches `recommendations:loaded`
 * on the element once it is filled — a NON-bubbling event, so it is caught
 * in the CAPTURE phase at document level, which every event passes through
 * on its way down to its target. The run-once flag guards the listener; the
 * drawer and the cart page can both load this file.
 */
(function () {
  if (window.__wbCartRecsBound) return;
  window.__wbCartRecsBound = true;

  function bind(block) {
    var grid = block.querySelector('.wb-rec__grid');
    if (!grid || grid.__wbRec) return;
    grid.__wbRec = true;

    var navBox = block.querySelector('[data-wb-rec-nav]');
    var prevBtn = block.querySelector('[data-wb-rec-prev]');
    var nextBtn = block.querySelector('[data-wb-rec-next]');
    var target = null, settle = null;

    function stripGap() { return parseFloat(getComputedStyle(grid).columnGap) || 8; }
    function isRtl() { return getComputedStyle(grid).direction === 'rtl'; }
    function offset() {
      var max = grid.scrollWidth - grid.clientWidth;
      var x = isRtl() ? -grid.scrollLeft : grid.scrollLeft;
      return Math.min(Math.max(x, 0), Math.max(max, 0));
    }
    function setState(btn, off) {
      if (btn) btn.setAttribute('aria-disabled', off ? 'true' : 'false');
    }
    function paintNav() {
      if (!navBox) return;
      var max = grid.scrollWidth - grid.clientWidth, x = offset();
      navBox.hidden = max <= 1;
      setState(prevBtn, x <= 1);
      setState(nextBtn, x >= max - 1);
      if (target !== null && Math.abs(x - target) < 1) target = null;
    }
    function page(dir, btn) {
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;
      var first = grid.firstElementChild, g = stripGap();
      var pitch = first ? first.getBoundingClientRect().width + g : 0;
      if (!pitch) return;
      var per = Math.max(1, Math.floor((grid.clientWidth + g) / pitch + 0.05));
      var max = Math.max(grid.scrollWidth - grid.clientWidth, 0);
      var idx = Math.round((target !== null ? target : offset()) / pitch);
      var to;
      if (dir > 0) to = (Math.floor(idx / per) + 1) * per;
      else if (target === null && offset() >= max - 1) to = Math.floor((max - 2) / (per * pitch)) * per;
      else to = (Math.ceil(idx / per) - 1) * per;
      target = Math.min(Math.max(to * pitch, 0), max);
      clearTimeout(settle);
      settle = setTimeout(function () { target = null; }, 900);
      grid.scrollTo({ left: isRtl() ? -target : target });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { page(-1, prevBtn); });
    if (nextBtn) nextBtn.addEventListener('click', function () { page(1, nextBtn); });
    grid.addEventListener('scroll', paintNav, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(paintNav).observe(grid);
    else window.addEventListener('resize', paintNav);
    paintNav();
  }

  document.addEventListener('recommendations:loaded', function (e) {
    var el = e.target;
    if (el && el.hasAttribute && el.hasAttribute('data-wb-recs')) bind(el);
  }, true);

  /* A row that filled before this (deferred) script ran — e.g. a cached
     fetch racing the script — is picked up here; bind() is idempotent. */
  var early = document.querySelectorAll('[data-wb-recs]');
  for (var i = 0; i < early.length; i++) bind(early[i]);
})();
